import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import './Item.scss';

/**
 * Item
 * @param {label, value, isLink} props
 * item with label on the left and value on the right
 */
const Item = (props) => {
  const {
    label, value, color, code, onClick, intl,
  } = props;

  const classes = classNames({
    'nw-item': true,
    'nw-item--single': !value,
    'nw-item--color': !!color,
  });

  return (
    <div className={classes} style={color ? { background: color } : {}} onClick={onClick}>
      <span className="nw-item__label">{color && code ? intl.formatMessage({ id: code }) : label}</span>
      {value && <span className="nw-item__value">{value}</span>}
    </div>
  );
};

Item.propTypes = {
  /** item label */
  label: PropTypes.node,
  /** item value */
  value: PropTypes.string,
};

Item.defaultProps = {
  label: null,
  value: null,
};

export default injectIntl(Item);
